var _defs, _clipPath, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect2, _rect3, _path15, _path16, _path17, _path18, _ellipse, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    enableBackground: "new 0 0 750 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 750,
    height: 500
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062898512250505708250000005751897672181355931_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011718479656119556590000014433529226561641150_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.0816,
    y1: 485.4378,
    x2: 758.0814,
    y2: 0.1047
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7630D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8094,
    style: {
      stopColor: "#0A1431"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)",
    fill: "url(#SVGID_00000011718479656119556590000014433529226561641150_)",
    width: 750,
    height: 500
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170960040566750158220000002585705514349754268_",
    gradientUnits: "userSpaceOnUse",
    x1: 588.7868,
    y1: -108.2786,
    x2: 477.1732,
    y2: 199.2972,
    gradientTransform: "matrix(0.9999 1.490000e-02 -1.490000e-02 0.9999 -0.5441 -3.3149)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#28095D",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0044"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)",
    fill: "url(#SVGID_00000170960040566750158220000002585705514349754268_)",
    d: " M768.5-18.4H270.4c21.9,58.2,81.9,167.3,233.4,215.4c109.4,34.7,201.4,14.2,264.8-13.8V-18.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136371807617407603090000016052041501204894607_",
    gradientUnits: "userSpaceOnUse",
    x1: 581.6674,
    y1: -184.3994,
    x2: 453.3018,
    y2: 169.3403,
    gradientTransform: "matrix(0.9983 -5.880000e-02 5.880000e-02 0.9983 -20.5021 86.1497)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#28095D",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0044"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)",
    fill: "url(#SVGID_00000136371807617407603090000016052041501204894607_)",
    d: " M768.5-18.4H198.3c24.5,59.7,100.2,196.1,292.2,241.7c114.2,27.1,208.9,5.3,278-26.1V-18.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045580336135246777460000006116748234512076420_",
    gradientUnits: "userSpaceOnUse",
    x1: 568.6857,
    y1: -256.5178,
    x2: 414.8297,
    y2: 167.4665,
    gradientTransform: "matrix(0.9834 -0.1813 0.1813 0.9834 -18.3861 194.0426)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#28095D",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0044"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)",
    fill: "url(#SVGID_00000045580336135246777460000006116748234512076420_)",
    d: " M768.5-18.4h-635C161.4,49.7,264.1,254.2,497.9,273c114.5,9.2,205.1-21.8,270.7-59.4V-18.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111907549008957472030000004812603000163819447_",
    gradientUnits: "userSpaceOnUse",
    x1: 536.6974,
    y1: -281.7108,
    x2: 365.8198,
    y2: 189.1803,
    gradientTransform: "matrix(0.9834 -0.1813 0.1813 0.9834 -18.3861 194.0426)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#28095D",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0044"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)",
    fill: "url(#SVGID_00000111907549008957472030000004812603000163819447_)",
    d: " M768.5-18.4H52.8c33.4,79.6,148,298.9,402.9,319.4c134.5,10.8,239.2-28.3,312.9-73.3V-18.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051376481285340801890000006843900997316099507_",
    gradientUnits: "userSpaceOnUse",
    x1: 504.6003,
    y1: -306.9836,
    x2: 316.6497,
    y2: 210.9556,
    gradientTransform: "matrix(0.9834 -0.1813 0.1813 0.9834 -18.3861 194.0426)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#28095D",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0044"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)",
    fill: "url(#SVGID_00000051376481285340801890000006843900997316099507_)",
    d: " M768.5-18.4H-28.2c38.7,90.5,165.1,325.3,441.5,347.5c154.8,12.5,273.8-35.2,355.2-87.6V-18.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174566301209258138490000006475292141040653206_",
    gradientUnits: "userSpaceOnUse",
    x1: 599.2628,
    y1: -84.3292,
    x2: 508.6451,
    y2: 165.3876,
    gradientTransform: "matrix(0.9768 0.2139 -0.2139 0.9768 27.0612 -106.0605)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#28095D",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0044"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)",
    fill: "url(#SVGID_00000174566301209258138490000006475292141040653206_)",
    d: " M768.5-2.7l-71.5-15.8H337.7c18,50.3,56.3,113.3,137.8,158.7c142.2,79.1,269.6,15.6,293.1,2.5V-2.7z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140720293383262347390000016052935463073131917_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.5763,
    y1: 237.9195,
    x2: 368.0208,
    y2: 398.8083
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7630D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6100A2",
      stopOpacity: 0
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000140720293383262347390000016052935463073131917_)",
    d: "M-28.1,127.1c0,0,152.8-16.3,297.8,79.8 c195.6,129.6,376,138.4,536,32.7v284.4H-30.8V130L-28.1,127.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135673617918986042700000012811684287262158219_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.2098,
    y1: 615.3041,
    x2: 437.3521,
    y2: 140.8026
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6105,
    style: {
      stopColor: "#6100A2",
      stopOpacity: 0.041436
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A56DCA",
      stopOpacity: 0.9
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000135673617918986042700000012811684287262158219_)",
    d: "M-1.3,128c25.5,0,65.8,2.3,113.2,13.5 c57,13.4,109.7,35.9,156.7,67c105.8,70.1,208.8,105.6,306.1,105.6c79.7,0,156.7-23.9,229-70.9v278.7H-28.8V130.8l1.6-1.8 C-24.5,128.7-15.4,128-1.3,128L-1.3,128 M-1.3,126c-17,0-26.8,1-26.8,1l-2.7,2.9v394h836.4V239.5c-72.9,48.2-150.1,72.6-231,72.6 c-96.6,0-198.6-34.8-305-105.3C161.4,135.1,48.8,126-1.3,126L-1.3,126z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071532422695472342030000013119175553537219513_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.3745,
    y1: 264.4663,
    x2: 319.4853,
    y2: 529.3555
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7630D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05581653,
    style: {
      stopColor: "#762CD4",
      stopOpacity: 0.9442
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4269,
    style: {
      stopColor: "#7514B9",
      stopOpacity: 0.5731
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7539,
    style: {
      stopColor: "#7405A8",
      stopOpacity: 0.2461
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7400A2",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174559739813495736060000012867846971098513331_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.4701,
    y1: 685.9482,
    x2: 465.9227,
    y2: 193.0495
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6105,
    style: {
      stopColor: "#6100A2",
      stopOpacity: 0.041436
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A56DCA",
      stopOpacity: 0.9
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)",
    fill: "url(#SVGID_00000071532422695472342030000013119175553537219513_)",
    stroke: "url(#SVGID_00000174559739813495736060000012867846971098513331_)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: " M-50.6,151c0,0,142.2-18.8,262.2,50.5C321.4,265,543.1,477.9,848,365.1v184H-57.8V154.6L-50.6,151z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124877947759527022480000009217484224925012871_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.1139,
    y1: 325.1191,
    x2: 241.1139,
    y2: 582.0078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D92588"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06389749,
    style: {
      stopColor: "#D0208C",
      stopOpacity: 0.9361
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2641,
    style: {
      stopColor: "#B81296",
      stopOpacity: 0.7359
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4773,
    style: {
      stopColor: "#A7089D",
      stopOpacity: 0.5227
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7102,
    style: {
      stopColor: "#9D02A1",
      stopOpacity: 0.2898
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A00A2",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088851767650577505410000013177652550790636456_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.4543,
    y1: 768.2532,
    x2: 390.302,
    y2: 305.8371
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6105,
    style: {
      stopColor: "#6100A2",
      stopOpacity: 0.041436
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A56DCA",
      stopOpacity: 0.9
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)",
    fill: "url(#SVGID_00000124877947759527022480000009217484224925012871_)",
    stroke: "url(#SVGID_00000088851767650577505410000013177652550790636456_)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: " M-71.6,171.6c0,0,197.3-37.9,347.8,123C407.3,434.9,559.5,505.3,724,507.9c0,54.2,0,144.9,0,144.9H-77V180.4L-71.6,171.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008835517850228384110000000893436369422795433_",
    gradientUnits: "userSpaceOnUse",
    x1: 368.7487,
    y1: 325.044,
    x2: 240.7522,
    y2: 581.9258,
    gradientTransform: "matrix(0.9815 0.1916 -0.1916 0.9815 28.7297 16.5641)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D92588"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06389749,
    style: {
      stopColor: "#D0208C",
      stopOpacity: 0.9361
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2641,
    style: {
      stopColor: "#B81296",
      stopOpacity: 0.7359
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4773,
    style: {
      stopColor: "#A7089D",
      stopOpacity: 0.5227
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7102,
    style: {
      stopColor: "#9D02A1",
      stopOpacity: 0.2898
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A00A2",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175303091824214432260000016595046640073192837_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.3431,
    y1: 774.0123,
    x2: 336.5553,
    y2: 313.1208
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6105,
    style: {
      stopColor: "#6100A2",
      stopOpacity: 0.041436
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A56DCA",
      stopOpacity: 0.9
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)",
    fill: "url(#SVGID_00000008835517850228384110000000893436369422795433_)",
    stroke: "url(#SVGID_00000175303091824214432260000016595046640073192837_)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: " M-74.8,171.1c0,0,200.9,0.6,317.8,187.3c101.8,162.8,237.7,261.1,398.7,295.2c-10.4,53.2-27.8,142.2-27.8,142.2l-786.2-153.5 l90.5-463.7L-74.8,171.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160896988913495531100000008230693064915054514_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.5222,
    y1: 325.2106,
    x2: 241.5184,
    y2: 582.1072,
    gradientTransform: "matrix(0.8948 0.4464 -0.4464 0.8948 70.3384 44.4994)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D92588"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06389749,
    style: {
      stopColor: "#D0208C",
      stopOpacity: 0.9361
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2641,
    style: {
      stopColor: "#B81296",
      stopOpacity: 0.7359
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4773,
    style: {
      stopColor: "#A7089D",
      stopOpacity: 0.5227
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7102,
    style: {
      stopColor: "#9D02A1",
      stopOpacity: 0.2898
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A00A2",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056401808201521460680000017339770723874332550_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.0677,
    y1: 791.6327,
    x2: 275.4208,
    y2: 316.9259
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6105,
    style: {
      stopColor: "#6100A2",
      stopOpacity: 0.041436
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A56DCA",
      stopOpacity: 0.9
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)",
    fill: "url(#SVGID_00000160896988913495531100000008230693064915054514_)",
    stroke: "url(#SVGID_00000056401808201521460680000017339770723874332550_)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: " M-70.1,166.3c0,0,193.5,54.2,256.3,265.3c54.7,184,159.5,315,305.6,390.8c-24.2,48.5-64.7,129.7-64.7,129.7l-716.8-357.6 l210.9-422.8L-70.1,166.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090263905068518319100000005965886406572653965_",
    gradientUnits: "userSpaceOnUse",
    x1: -107.9496,
    y1: 970.3167,
    x2: 97.0952,
    y2: 205.0791
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6105,
    style: {
      stopColor: "#6100A2",
      stopOpacity: 0.041436
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A56DCA",
      stopOpacity: 0.9
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)",
    fill: "#A20097",
    stroke: "url(#SVGID_00000090263905068518319100000005965886406572653965_)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: " M-64.2,163c0,0,172,103.8,176.3,324c3.7,192,69.7,346.1,190.3,458.2c-36.3,40.3-96.9,107.7-96.9,107.7L-390,517.1l316-351.2 L-64.2,163z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116924114431981325950000016200260395485184168_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.2712,
    y1: 324.7096,
    x2: 241.2732,
    y2: 581.5945,
    gradientTransform: "matrix(0.5381 0.8429 -0.8429 0.5381 125.0872 129.4065)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D92588"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01024938,
    style: {
      stopColor: "#D82488",
      stopOpacity: 0.9898
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2221,
    style: {
      stopColor: "#C0148F",
      stopOpacity: 0.7779
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4469,
    style: {
      stopColor: "#AF0993",
      stopOpacity: 0.5531
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6933,
    style: {
      stopColor: "#A50296",
      stopOpacity: 0.3067
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A20097",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024711481223527265880000000959375178671601070_",
    gradientUnits: "userSpaceOnUse",
    x1: -273.5644,
    y1: 1027.7244,
    x2: -42.3549,
    y2: 164.8389
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6105,
    style: {
      stopColor: "#6100A2",
      stopOpacity: 0.041436
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A56DCA",
      stopOpacity: 0.9
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)",
    fill: "url(#SVGID_00000116924114431981325950000016200260395485184168_)",
    stroke: "url(#SVGID_00000024711481223527265880000000959375178671601070_)",
    strokeMiterlimit: 10,
    d: " M-57.7,161.3c0,0,138.1,145.9,83.5,359.3c-47.6,186-25.1,352.2,61.2,492.3c-45.7,29.2-122.1,78-122.1,78l-431-675.1L-68,161.5 L-57.7,161.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000040543245659270104770000015805251210044814264_",
    cx: 579.567,
    cy: -118.2785,
    r: 644.9789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3300A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3300A2",
      stopOpacity: 0
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)",
    fill: "url(#SVGID_00000040543245659270104770000015805251210044814264_)",
    width: 750,
    height: 500
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000165952489360074252040000013754321327878313115_",
    cx: 43.0267,
    cy: 471.055,
    r: 520.9978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A20071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A20071",
      stopOpacity: 0
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)",
    fill: "url(#SVGID_00000165952489360074252040000013754321327878313115_)",
    width: 750,
    height: 500
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000103225946765630900860000016417398039165429915_",
    cx: 386.9295,
    cy: 135.4779,
    r: 130.5671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E00A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E00A2",
      stopOpacity: 0
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)",
    fill: "none",
    stroke: "url(#SVGID_00000103225946765630900860000016417398039165429915_)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: " M230,40.1c0,0,81.8,164.7,314.7,190.2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000107553083383455391210000006756925043246032830_",
    cx: 435.904,
    cy: 177.5086,
    r: 192.2297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E00A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E00A2",
      stopOpacity: 0
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)",
    fill: "none",
    stroke: "url(#SVGID_00000107553083383455391210000006756925043246032830_)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: " M183.9,78.2c0,0,100,176.4,321.3,196.5c105.5,9.6,183.1-24.7,183.1-24.7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000010286734910964497960000000858344789470690493_",
    cx: 369.4342,
    cy: 94.8846,
    r: 84.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E00A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E00A2",
      stopOpacity: 0
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)",
    fill: "none",
    stroke: "url(#SVGID_00000010286734910964497960000000858344789470690493_)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: " M283.9,13.7c0,0,39.6,101.8,171.6,161.8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000125603540046791791080000014704231835824255361_",
    cx: 427.5059,
    cy: 81.3928,
    r: 79.1307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E00A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E00A2",
      stopOpacity: 0
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)",
    fill: "none",
    stroke: "url(#SVGID_00000125603540046791791080000014704231835824255361_)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: " M347,5c0,0,37.2,95.8,161.5,152.3"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000062898512250505708250000005751897672181355931_)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000004518271462801438030000004477434431315876253_",
    cx: -461.6883,
    cy: -66.8751,
    r: 290.3407,
    gradientTransform: "matrix(0.9355 0 0 0.9363 1161.1884 0.9168)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#845DC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#845DC7",
      stopOpacity: 0
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.7,
    fill: "url(#SVGID_00000004518271462801438030000004477434431315876253_)",
    cx: 689.6,
    cy: -59.5,
    rx: 314.6,
    ry: 314.9
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground01);
export default __webpack_public_path__ + "static/media/background-01.5aa7b2103c119e594745973da9b6068f.svg";
export { ForwardRef as ReactComponent };